module.exports = __webpack_public_path__ + "static/media/logo.f803d26b.png";